module.exports = __webpack_public_path__ + "img/testpreviewIllustration.35ba88b0.svg";